/**
 * Static-translations for it. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const it = {
  'anon.description_default': 'Configurazione della sessione ospite…',
  'anon.heading_default': 'Continua come ospite',
  'anon.try_again': 'Riprova',
  'auth.back_to_login': 'Torna all\'accesso',
  'auth.check_email_message': 'Controlla la tua email per il codice di conferma.',
  'auth.check_email_title': 'Controlla la tua email',
  'auth.confirm_email_subtitle': 'Inserisci il codice che abbiamo inviato alla tua email per completare la registrazione.',
  'auth.confirm_email_title': 'Conferma la tua email',
  'auth.confirmation_code': 'Codice di conferma',
  'auth.continue_with_apple': 'Continua con Apple',
  'auth.continue_with_facebook': 'Continua con Facebook',
  'auth.continue_with_github': 'Continua con GitHub',
  'auth.continue_with_google': 'Continua con Google',
  'auth.create_account': 'Crea account',
  'auth.default_subtitle': 'Acceda per accedere a tutte le funzionalità e sincronizzare i suoi dati.',
  'auth.email': 'Indirizzo e-mail',
  'auth.email_already_registered': 'Questa email è già registrata. Accedi qui sotto con la password o l\'account che hai usato per registrarti.',
  'auth.email_exists': 'Esiste già un account con questa email.',
  'auth.email_not_confirmed': 'Conferma prima la tua email.',
  'auth.forgot_password': 'Ha dimenticato la password?',
  'auth.forgot_password_title': 'Ha dimenticato la password?',
  'auth.forgot_subtitle': 'Inserisca il suo indirizzo e-mail e le invieremo un collegamento per reimpostare la password.',
  'auth.generic_error': 'Qualcosa è andato storto',
  'auth.have_account': 'Ha un account?',
  'auth.hide_password': 'Nascondi password',
  'auth.identity_already_linked': 'Questo account è già registrato. Accedi con esso qui sotto.',
  'auth.invalid_credentials': 'Email o password non validi',
  'auth.invalid_otp': 'Il codice non è valido o è scaduto.',
  'auth.last_used': 'Ultima volta · {email}',
  'auth.last_used_no_email': 'Ultima volta',
  'auth.link_purchase_subheading': 'Collegheremo l\'acquisto al tuo account per mantenere l\'accesso.',
  'auth.log_in': 'Accedi',
  'auth.log_in_link': 'Accedi',
  'auth.login_continue_purchase': 'Acceda per continuare il suo acquisto',
  'auth.network_error': 'Errore di rete. Controlla la connessione e riprova.',
  'auth.new_password_optional': 'Nuova password (opzionale — solo per il reset)',
  'auth.no_account': 'Non ha un account?',
  'auth.or': 'oppure',
  'auth.password': 'Password',
  'auth.passwords_mismatch': 'Le password non corrispondono',
  'auth.rate_limited': 'Troppe richieste. Riprova più tardi.',
  'auth.repeat_password': 'Ripeti password',
  'auth.reset_link_valid': 'Il link è valido per 1 ora.',
  'auth.reset_password_subtitle': 'Inserisci il codice dall\'email e una nuova password.',
  'auth.reset_password_title': 'Reimposta password',
  'auth.reset_sent_message': 'Se l\'email esiste, è stato inviato un codice di reimpostazione.',
  'auth.reset_sent_subtitle': 'Abbiamo inviato un link per reimpostare la password. Segui le istruzioni nell\'email.',
  'auth.restore_purchases_heading': 'Ripristina Acquisti',
  'auth.restore_purchases_subheading': 'La preghiamo di accedere per ripristinare i suoi acquisti.',
  'auth.send_reset': 'Invia E-mail di Ripristino',
  'auth.service_unavailable': 'Servizio temporaneamente non disponibile. Riprova più tardi.',
  'auth.show_password': 'Mostra password',
  'auth.sign_out': 'Disconnetti',
  'auth.sign_up': 'Registrati',
  'auth.sign_up_link': 'Registrati',
  'auth.signed_in': 'Connesso',
  'auth.signin_failed': 'Accesso non riuscito',
  'auth.signup_failed': 'Registrazione non riuscita',
  'auth.verify': 'Verifica',
  'auth.weak_password': 'La password è troppo debole.',
  'auth.welcome': 'Benvenuto!',
  'auth.welcome_signup': 'Benvenuto!',
  'cta.close': 'Chiudi',
  'cta.continue': 'Continua',
  'cta.get_lifetime_access': 'Ottieni accesso a vita',
  'cta.get_plan_daily': 'Ottieni piano giornaliero',
  'cta.get_plan_generic': 'Ottieni piano {interval}',
  'cta.get_plan_monthly': 'Ottieni piano mensile',
  'cta.get_plan_weekly': 'Ottieni piano settimanale',
  'cta.get_plan_yearly': 'Ottieni piano annuale',
  'cta.start_trial': 'Inizia Prova Gratuita di {days} Giorni',
  'modal.close_aria': 'Chiudi',
  'modal.continue': 'Continua',
  'modal.error_generic': 'Qualcosa è andato storto',
  'modal.loading': 'Caricamento…',
  'modal.purchase_restored_subtitle': 'Tutto pronto — buon divertimento!',
  'modal.purchase_restored_title': 'Bentornato',
  'modal.purchase_success_subtitle': 'Tutto pronto — buon divertimento!',
  'modal.purchase_success_title': 'Pagamento ricevuto',
  'modal.verifying_subscription': 'Verifica dell\'abbonamento…',
  'nav.back': '← Indietro',
  'nav.back_aria': 'Indietro',
  'offer.limited_time': 'Offerta a tempo limitato',
  'payment.awaiting_subtitle': 'Rileveremo automaticamente il tuo pagamento — oppure clicca sotto quando hai finito.',
  'payment.awaiting_title': 'Completa il pagamento nella nuova scheda',
  'payment.checking': 'Verifica…',
  'payment.ive_paid': 'Ho pagato',
  'payment.open_checkout_again': 'Apri checkout di nuovo',
  'payment.open_checkout_button': 'Apri checkout',
  'payment.popup_blocked_message': 'Il browser ha bloccato la scheda di checkout. Clicca sotto per aprirla.',
  'payment.popup_blocked_title': 'Consenti i pop-up per continuare',
  'payment.popup_help_text': 'La finestra di checkout non si è aperta o è stata bloccata? Clicca qui per riaprirla.',
  'payment.still_processing': 'Il pagamento è ancora in elaborazione. Riprova tra un momento.',
  'payment.tab_closed_retry': 'Scheda chiusa? Riprova',
  'pricing.free_trial_days': 'Prova gratuita di {days} giorni',
  'pricing.included_per': 'Incluso per {interval}:',
  'pricing.interval.day': 'giorno',
  'pricing.interval.lifetime_short': 'a vita',
  'pricing.interval.month': 'mese',
  'pricing.interval.period': 'periodo',
  'pricing.interval.week': 'settimana',
  'pricing.interval.year': 'anno',
  'pricing.money_back': 'Garanzia di rimborso di 30 giorni',
  'pricing.most_popular': 'Più popolare',
  'pricing.no_prices': 'Nessun prezzo disponibile.',
  'pricing.plan_label.daily': 'PIANO GIORNALIERO',
  'pricing.plan_label.lifetime': 'a vita',
  'pricing.plan_label.monthly': 'piano mensile',
  'pricing.plan_label.weekly': 'piano settimanale',
  'pricing.plan_label.yearly': 'piano annuale',
  'pricing.plans_aria': 'Piani',
  'session.contact_support': 'Contatta il supporto',
  'session.restore_purchases': 'Ripristina acquisti',
  'session.sign_out': 'Disconnetti',
  'session.signed_in_as_prefix': 'Connesso come',
  'session.signing_out': 'Disconnessione…',
  'support.attachments_aria': 'Caricamento allegati',
  'support.attachments_label': 'Allegati',
  'support.close_button': 'Chiudi',
  'support.done_button': 'Fatto',
  'support.dropzone_text': 'Trascina qui le immagini o fai clic per selezionarle',
  'support.email_placeholder': 'Inserisca il suo indirizzo e-mail',
  'support.file_requirements': 'JPEG/PNG/WebP, fino a {max} file, ≤ {size} MB ciascuno',
  'support.heading': 'Supporto',
  'support.instruction': 'La preghiamo di compilare il modulo qui sotto per inviare la sua richiesta di supporto.',
  'support.invalid_email': 'E-mail non valida',
  'support.invalid_file': 'Solo JPEG/PNG/WebP, ≤ {size} MB ciascuno',
  'support.message_length': '1–5000 caratteri',
  'support.message_placeholder': 'Inserisca il suo messaggio',
  'support.remove_file_aria': 'Rimuovi {filename}',
  'support.required': 'Obbligatorio',
  'support.send_another': 'Invia un\'altra richiesta',
  'support.send_button': 'Invia',
  'support.sending': 'Invio in corso…',
  'support.sending_as': 'Invio come',
  'support.subject_length': '3–200 caratteri',
  'support.subject_placeholder': 'Inserisca l\'oggetto',
  'support.success_heading': 'Richiesta inviata',
  'support.success_message_prefix': 'Abbiamo ricevuto il suo messaggio e risponderemo a',
  'support.too_many_files': 'Fino a {max} file'
} as const;

export default it;
